import { render, staticRenderFns } from "./IPBlacklist.vue?vue&type=template&id=6b1654fe&"
import script from "./IPBlacklist.vue?vue&type=script&lang=js&"
export * from "./IPBlacklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/l-setting-for-configuration-tool/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b1654fe')) {
      api.createRecord('6b1654fe', component.options)
    } else {
      api.reload('6b1654fe', component.options)
    }
    module.hot.accept("./IPBlacklist.vue?vue&type=template&id=6b1654fe&", function () {
      api.rerender('6b1654fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UIComponents/IPBlacklist.vue"
export default component.exports